define([], function() {

	console.log('Version:', $ENV.VERSION);

	return {
		VERSION: $ENV.VERSION,
		IMAGES_URL: 'img/',
		IMAGES: {
			FIDO_ICON: {
				image: 'fido-u2f.png',
				width: 82,
				height: 100
			},
			FIDO_ANI: {
				image: 'fido_ani.gif',
				width: 82,
				height: 100
			},
			FIDO_ANI_PNG: {
				image: 'fido_ani.png',
				width: 82,
				height: 100
			},
			FIDO_ANI_MP4: {
				image: 'fido_ani.mp4',
				width: 82,
				height: 100
			},
			FIDO_ANI_OGV: {
				image: 'fido_ani.ogv',
				width: 82,
				height: 100
			},
			IDS_MOBILE: {
				image: 'ids_mobile.png',
				width: 986,
				height: 986
			},
			IDS_LOCAL: {
				image: 'ids_local.png',
				width: 986,
				height: 647
			},
			CLOUDID_ICON: {
				image: 'cloudid.png',
				width: 23,
				height: 23
			},
			SERVER_ICON: {
				image: 'server.png',
				width: 82,
				height: 100
			},
			PDF_ICON: {
				image: 'pdf.png',
				width: 128,
				height: 153
			},
			WEBSTART_RECOVERY_BUTTON: {
				de: {
					image: 'jnlp-download.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'jnlp-download.png',
					width: 513,
					height: 162
				}
			},
			OPEN_ECARD_APP_RECOVERY_BUTTON: {
				de: {
					image: 'open-ecard-app-recovery-de.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'open-ecard-app-recovery-en.png',
					width: 513,
					height: 162
				}
			},
			MANUAL_RECOVERY_BUTTON: {
				de: {
					image: 'eID-Client.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'eID-Client.png',
					width: 513,
					height: 162
				}
			},
			CUSTOM_PROTOCOL_RECOVERY_BUTTON: {
				de: {
					image: 'custom-protocol-recovery-de.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'custom-protocol-recovery-en.png',
					width: 513,
					height: 162
				}
			}
		},
		IMAGES_TO_PRELOAD: [
			'CLOUDID_ICON',
			'SERVER_ICON',
			'PDF_ICON',
			'WEBSTART_RECOVERY_BUTTON',
			'OPEN_ECARD_APP_RECOVERY_BUTTON',
			'MANUAL_RECOVERY_BUTTON',
			'CUSTOM_PROTOCOL_RECOVERY_BUTTON'
		],

		LOGO_CANVAS_INTERVAL: 300,
		LOADING_CANVAS_INTERVAL: 25
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/environment/environment.common.js
// module id = 69
// module chunks = 5 7